import { render, staticRenderFns } from "./ExpertCard.vue?vue&type=template&id=78fa0d81&scoped=true"
import script from "./ExpertCard.vue?vue&type=script&lang=js"
export * from "./ExpertCard.vue?vue&type=script&lang=js"
import style0 from "./ExpertCard.vue?vue&type=style&index=0&id=78fa0d81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa0d81",
  null
  
)

export default component.exports